import { Component } from '@angular/core';

interface Notification {
  id: number;
  title: string;
  message: string;
  type: 'success' | 'warning' | 'info';
  date: string;
  read: boolean;
  icon: string;
}

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent {
  notifications: Notification[] = [
    {
      id: 1,
      title: 'Cita Confirmada',
      message: 'Tu cita en Taller Mecánico XYZ para el Toyota Corolla ha sido confirmada',
      type: 'success',
      date: 'Hace 5 minutos',
      read: false,
      icon: 'check_circle',
    },
    {
      id: 2,
      title: 'Recordatorio de Mantenimiento',
      message: 'Tu vehículo Toyota Corolla necesita mantenimiento programado',
      type: 'warning',
      date: 'Hace 1 hora',
      read: false,
      icon: 'warning',
    },
    {
      id: 3,
      title: 'Nueva Promoción',
      message: '¡Descuento del 20% en servicios de mantenimiento!',
      type: 'info',
      date: 'Hace 2 horas',
      read: true,
      icon: 'info',
    },
    {
      id: 4,
      title: 'Servicio Completado',
      message: 'El servicio de cambio de aceite para tu Toyota Corolla ha sido completado',
      type: 'success',
      date: 'Ayer',
      read: true,
      icon: 'check_circle',
    },
  ];

  markAsRead(notification: Notification) {
    notification.read = true;
  }

  markAllAsRead() {
    this.notifications.forEach((n) => (n.read = true));
  }
}
